import { HomeDashboardComponent } from "@/components/HomeDashboardComponent";

function Home() {
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      <HomeDashboardComponent />
    </div>
  );
}

export default Home;
